import { customField } from '@libs/domain';
import { customFieldAttribute } from '@libs/enums';
import { FieldSet, useItemName } from '@ps-smart-cp/ppfw-client';
import { customFieldBasicSettingFieldConfig } from '../item-config';
import type { CustomFieldBasicSetting } from '../models';
import { CustomFieldBasicSettingRow } from './CustomFieldBasicSettingRow';

interface CustomFieldBasicSettingFieldSetProps {
  settings: CustomFieldBasicSetting[];
  setSettings: (setting: CustomFieldBasicSetting[]) => void;
  errorFields?: string[];
}

// TODO: カスタムフィールド設定のstyled-component対応(https://proship-infra.atlassian.net/browse/AFW-326)
function CustomFieldBasicFieldSet({
  settings,
  setSettings,
  errorFields,
}: CustomFieldBasicSettingFieldSetProps) {
  const getName = useItemName();

  return (
    <FieldSet
      legendProps={{
        title: getName(customField.names.customFieldBasicInfo),
        id: 'custom-field-basic-setting-field-set',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '200px 100px repeat(2, 1fr) 2fr',
          gridTemplateRows: '26px repeat(6, 27px)',
        }}
      >
        <div style={{ display: 'contents' }}>
          <div style={{ gridArea: '1/2', textAlign: 'center' }}>
            {getName(customFieldBasicSettingFieldConfig.isUsed)}
          </div>
          <div style={{ gridArea: '1/3', textAlign: 'center' }}>
            {getName(customFieldBasicSettingFieldConfig.displayName)}
          </div>
          <div style={{ gridArea: '1/4', textAlign: 'center' }}>
            {getName(customFieldBasicSettingFieldConfig.attribute)}
          </div>
          <div style={{ gridArea: '1/5', textAlign: 'center' }}>
            {getName(customFieldBasicSettingFieldConfig.codeDigits)}
          </div>
        </div>
        {settings.map((row) => {
          return (
            <CustomFieldBasicSettingRow
              key={row.customFieldKey}
              setting={row}
              setSetting={(changed) =>
                setSettings(
                  settings.map((checkRow) => {
                    if (checkRow.customFieldKey === row.customFieldKey) {
                      if (changed.attribute === customFieldAttribute.enum.freeFormat) {
                        return { ...changed, codeDigits: '' };
                      } else {
                        return changed;
                      }
                    } else {
                      return checkRow;
                    }
                  }),
                )
              }
              errorFields={errorFields}
            />
          );
        })}
        <div style={{ gridColumn: '6', gridRow: '1/6' }}></div>
      </div>
    </FieldSet>
  );
}

export { CustomFieldBasicFieldSet };
export type { CustomFieldBasicSettingFieldSetProps };
